"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.instancesToListDataItems = void 0;
const tslib_1 = require("tslib");
/// <reference path="List.d.ts" />
const Utilities_1 = require("../../javascript/Utilities");
const synerisMethods_1 = require("../Menu/synerisMethods");
const FieldNameConverter_1 = require("./FieldNameConverter");
const LayoutStorage_1 = require("./LayoutStorage");
const Base_1 = require("../../model/Base");
const ListFilterable_1 = require("./ListFilterable");
const _less = require("./List.tmpl.less");
var ListPrivateDataKeys;
(function (ListPrivateDataKeys) {
    ListPrivateDataKeys[ListPrivateDataKeys["LayoutStorageKey"] = 0] = "LayoutStorageKey";
    ListPrivateDataKeys[ListPrivateDataKeys["LastSelection"] = 1] = "LastSelection";
    ListPrivateDataKeys[ListPrivateDataKeys["ColLayoutEtagClient"] = 2] = "ColLayoutEtagClient";
    ListPrivateDataKeys[ListPrivateDataKeys["ColLayoutEtagServer"] = 3] = "ColLayoutEtagServer";
    ListPrivateDataKeys[ListPrivateDataKeys["Columns"] = 4] = "Columns";
    ListPrivateDataKeys[ListPrivateDataKeys["IsInitialized"] = 5] = "IsInitialized";
})(ListPrivateDataKeys || (ListPrivateDataKeys = {}));
function instancesToListDataItems(instances) {
    return instances.map((instance) => {
        let dataItem = {
            id: instance.id.valueAsString,
            icon: instance.icon.valueAsString
        };
        for (let fieldName in instance.items) {
            const field = instance.items[fieldName];
            if (field.multiValue) {
                let str = "";
                for (let i = 0; i < field.valueAsArray.length; i++) {
                    if (i > 0)
                        str += ";";
                    if (field.valueAsArray[i] != undefined) {
                        switch (field.type) {
                            case Base_1.FieldType.Date:
                                str += kendo.toString(field.valueAsDateArray[i], "d");
                                break;
                            case Base_1.FieldType.DateTime:
                                str += kendo.toString(field.valueAsDateArray[i], "G");
                                break;
                            case Base_1.FieldType.Time:
                                str += kendo.toString(field.valueAsDateArray[i], "T");
                                break;
                            case Base_1.FieldType.Bool:
                                str += (field.valueAsBooleanArray[i] ? "Y" : "N");
                                break;
                            case Base_1.FieldType.Float:
                                str += kendo.toString(field.valueAsNumberArray[i], "n2");
                                break;
                            case Base_1.FieldType.Digit:
                            case Base_1.FieldType.BigDigit:
                            default:
                                str += field.valueAsArray[i].toString();
                                break;
                        }
                    }
                }
                dataItem[FieldNameConverter_1.FieldNameConverter.toInternalName(field.name)] = str;
            }
            else
                dataItem[FieldNameConverter_1.FieldNameConverter.toInternalName(field.name)] = field.valueAsSingleValue;
        }
        return dataItem;
    });
}
exports.instancesToListDataItems = instancesToListDataItems;
class ListImpl {
    //#region JQuery plugin functions
    static initAsync($elem, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let synData = ListImpl.getData($elem);
            if (!synData) {
                synData = $.extend({}, ListImpl.DefaultOptions, options);
                if (!synData.selectionMode)
                    synData.selectionMode = Utilities_1.synUtil.clientDeviceClass === "desktop" ? "Multiple" : "Single";
                ListImpl.setData($elem, synData);
                yield ListImpl.initListControlAsync($elem);
                $elem.addClass("synList");
                if (Utilities_1.synUtil.isHDScreen)
                    $elem.addClass("HDScreen");
                ListImpl.setPrivateData($elem, ListPrivateDataKeys.IsInitialized, true);
            }
        });
    }
    static destroy($elem) {
        return $elem.each((_idx, elem) => {
            const $this = $(elem);
            if (!ListImpl.getData($this))
                return;
            if ($this.data("kendoGrid"))
                $this.data("kendoGrid").destroy();
            $this.off("fetchedIds")
                .off("selectionChanged")
                .off("onObjectContextMenu")
                .off("beforeSelectionChanged")
                .off("rowDoubleClicked")
                .off("beginDataBinding")
                .off("dataBound")
                .off("endDataBinding")
                .removeClass("synList")
                .removeData("synList");
            Object.keys(ListPrivateDataKeys)
                .filter(k => !isNaN(parseInt(k, 10)))
                .map(k => parseInt(k, 10))
                .forEach((key) => { ListImpl.deletePrivateData($elem, key); });
        });
    }
    static isInitialized($elem) {
        return ListImpl.getPrivateData($elem, ListPrivateDataKeys.IsInitialized);
    }
    static clear($elem) {
        return $elem.each((_idx, elem) => {
            const $this = $(elem);
            if (!ListImpl.getData($this) || !$this.data("kendoGrid"))
                return;
            $this.data("kendoGrid").dataSource.data([]);
        });
    }
    static refresh($elem) {
        return $elem.each((_idx, elem) => {
            const $this = $(elem);
            if (!ListImpl.getData($this) || !$this.data("kendoGrid"))
                return;
            const selectedIds = ListImpl.getSelectedIds($this);
            $this.one("dataBound", () => {
                if (!ListImpl.select($this, ...selectedIds))
                    $this.trigger("selectionChanged", [ListImpl.getSelectedIds($this)]);
            });
            $this.data("kendoGrid").dataSource.read();
        });
    }
    static refreshAsync($elem) {
        return new Promise((resolve) => {
            $elem.one("dataBound", () => { resolve(); });
            ListImpl.refresh($elem);
        });
    }
    static getSelectedIds($elem) {
        return ListImpl.getSelectedItems($elem)
            .map(item => item.id);
    }
    static getSelectedItems($elem) {
        const grid = $elem.data("kendoGrid");
        if (!grid)
            return [];
        return grid.select()
            .toArray()
            .map((row) => grid.dataItem(row));
    }
    static select($elem, ...ids) {
        const grid = $elem.data("kendoGrid");
        if (!grid)
            return false;
        let mapIdsToSelect = {};
        ids.forEach((id) => {
            mapIdsToSelect[id] = true;
        });
        if (Object.keys(mapIdsToSelect).length) {
            let $selection = $();
            grid.tbody.children("tr")
                .toArray()
                .forEach(tr => {
                const dataItem = grid.dataItem(tr);
                if (mapIdsToSelect[dataItem.get("id")])
                    $selection = $selection.add(tr);
            });
            grid.select($selection);
            return $selection.length === ids.length;
        }
        return true;
    }
    static getItems($elem) {
        const grid = $elem.data("kendoGrid");
        if (!grid)
            return [];
        return grid.dataSource.data().map(i => i);
    }
    static getItemCount($elem) {
        return ListImpl.getItems($elem).length;
    }
    static update($elem, instances) {
        return $elem.each((_idx, elem) => {
            const $this = $(elem);
            if (ListImpl.isInitialized($this)) {
                let grid = $this.data("kendoGrid");
                if (!grid)
                    return;
                let selectedIdsBeforeUpdate = grid.select()
                    .toArray()
                    .map(tr => grid.dataItem(tr).get("id"));
                const dataItems = instancesToListDataItems(instances);
                let mapDataItems = {};
                for (let dataItem of dataItems)
                    mapDataItems[dataItem.id] = dataItem;
                let ds = grid.dataSource;
                let data = ds.data();
                for (let idx = 0; idx < data.length; ++idx) {
                    let curItem = data[idx];
                    let updateItem = mapDataItems[curItem.get("id")];
                    if (updateItem)
                        data.splice(idx, 1, updateItem);
                }
                ListImpl.select($this, ...selectedIdsBeforeUpdate);
            }
        });
    }
    static delete($elem, instances) {
        return $elem.each((_idx, elem) => {
            const $this = $(elem);
            if (ListImpl.isInitialized($this)) {
                let grid = $this.data("kendoGrid");
                if (!grid)
                    return;
                let ds = grid.dataSource;
                let changedSelection = false;
                for (let idx = 0; idx < instances.length; ++idx) {
                    let dataItem = ds.get(instances[idx].id.value);
                    if (dataItem) {
                        const tr = grid.tbody.children("tr")[idx];
                        if ($.contains(grid.tbody[0], tr))
                            changedSelection = true;
                        ds.remove(dataItem);
                    }
                }
                if (changedSelection) {
                    let selectedIds = ListImpl.getSelectedIds($elem);
                    $elem.trigger("selectionChanged", [selectedIds]);
                }
            }
        });
    }
    static add($elem, instances) {
        return $elem.each((_idx, elem) => {
            const $this = $(elem);
            if (ListImpl.isInitialized($this)) {
                let grid = $this.data("kendoGrid");
                if (!grid)
                    return;
                let selectedIdsBeforeUpdate = grid.select()
                    .toArray()
                    .map(tr => grid.dataItem(tr).get("id"));
                const dataItems = instancesToListDataItems(instances);
                let ds = $this.data("kendoGrid").dataSource;
                let data = ds.data();
                let mapExisting = {};
                for (let idx = 0; idx < data.length; ++idx)
                    mapExisting[data[idx].get("id")] = true;
                const newItems = dataItems.filter((di => !mapExisting[di["id"]]));
                for (let idx = 0; idx < newItems.length; ++idx)
                    data.push(newItems[idx]);
                ListImpl.select($this, ...selectedIdsBeforeUpdate);
            }
        });
    }
    static focus($elem, focused) {
        return $elem.toggleClass("unfocused", !focused);
    }
    static isFocused($elem) {
        return !$elem.hasClass("unfocused");
    }
    static updateColLayoutAsync($elem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let hasChanged = false;
            let grid = $elem.data("kendoGrid");
            if (grid && !ListImpl.isStaticColLayout($elem)) {
                const colLayout = yield ListImpl.getColLayoutAsync($elem);
                if (ListImpl.layoutHasChanged($elem, colLayout)) {
                    hasChanged = true;
                    // Remember the currentl selected elements, we have to restore selection later
                    let mapOldSelection = {};
                    grid.select()
                        .toArray()
                        .map(elem => grid.dataItem(elem))
                        .forEach((item => { mapOldSelection[item.get("id")] = true; }));
                    ListImpl.setPrivateData($elem, ListPrivateDataKeys.Columns, colLayout.columns);
                    ListImpl.updateLayoutEtag($elem, colLayout);
                    let options = grid.getOptions();
                    options.columns = ListImpl.toKendoGridColumns($elem, colLayout);
                    const refreshPromise = new Promise((resolve) => {
                        $elem.one("dataBound", () => { window.setTimeout(resolve, 1); });
                        grid.setOptions(options); // this will re-fetch data from dataSource...
                    });
                    yield refreshPromise; //...which is why we need to await it...
                    if (Object.keys(mapOldSelection).length) {
                        // ... so we can restore the selection we have remembered at the beginning
                        grid = $elem.data("kendoGrid");
                        // We have to restore the selection.
                        // THE FOLLOWING CONSTRUCT SEEMS TO BE THE ONLY WAY THAT WORKS.
                        // Changing the column layout appears to incur strange derelictions in the DOM,
                        // which is why the usual way with remembering the selected ids and calling
                        // List.select() won't work here.
                        let selIndexes = [];
                        grid.dataSource.data()
                            .forEach((dataItem, idx) => {
                            if (mapOldSelection[dataItem.get("id")]) {
                                selIndexes.push(idx);
                                delete mapOldSelection[dataItem.get("id")];
                            }
                        });
                        let $sel = $();
                        for (let idx of selIndexes)
                            $sel = $sel.add($elem.find("tbody > tr")[idx]);
                        grid.select($sel);
                        if (Object.keys(mapOldSelection).length) {
                            // Not all previously selected items exist anymore. We have to raise a
                            // selectionChanged event.
                            const selectedIds = grid.select()
                                .toArray()
                                .map(elem => grid.dataItem(elem).get("id"));
                            $elem.trigger("selectionChanged", [selectedIds]);
                        }
                    }
                }
            }
            return hasChanged;
        });
    }
    static getColumns($elem) {
        return ListImpl.getPrivateData($elem, ListPrivateDataKeys.Columns);
    }
    static lock($elem, lock) {
        return $elem.each((_idx, elem) => {
            const $this = $(elem);
            const synData = ListImpl.getData($this);
            if (synData === null || synData === void 0 ? void 0 : synData.lockable)
                $this.toggleClass("k-state-disabled", lock);
        });
    }
    //#endregion JQuery plugin functions
    //#region Helpers
    static updateLayoutEtag($elem, colLayout) {
        const synData = ListImpl.getData($elem);
        if (!ListImpl.isStaticColLayout($elem)) {
            const eTagClient = LayoutStorage_1.LayoutStorage.getLayoutETag(synData.columnOptions);
            if (eTagClient)
                ListImpl.setPrivateData($elem, ListPrivateDataKeys.ColLayoutEtagClient, eTagClient);
            else
                ListImpl.deletePrivateData($elem, ListPrivateDataKeys.ColLayoutEtagClient);
            ListImpl.setPrivateData($elem, ListPrivateDataKeys.ColLayoutEtagServer, colLayout.etag);
        }
        else {
            ListImpl.deletePrivateData($elem, ListPrivateDataKeys.ColLayoutEtagClient);
            ListImpl.deletePrivateData($elem, ListPrivateDataKeys.ColLayoutEtagServer);
        }
    }
    static layoutHasChanged($elem, colLayout) {
        const synData = ListImpl.getData($elem);
        if (ListImpl.isStaticColLayout($elem))
            return false;
        const clientETagCur = LayoutStorage_1.LayoutStorage.getLayoutETag(synData.columnOptions);
        const clientETagLast = ListImpl.getPrivateData($elem, ListPrivateDataKeys.ColLayoutEtagClient);
        const serverETagCur = colLayout.etag;
        const serverETagLast = ListImpl.getPrivateData($elem, ListPrivateDataKeys.ColLayoutEtagServer);
        return clientETagCur !== clientETagLast || serverETagCur !== serverETagLast;
    }
    static registerContextMenu($elem) {
        let $contextMenuElement = $elem.find(".k-grid-content");
        if ($contextMenuElement) {
            $contextMenuElement.on("contextmenu", (eventObjectContextMenu) => {
                if (Utilities_1.synUtil.clientDeviceClass === "desktop") {
                    /* Das ContextMenu gibt es derzeit nur im Desktop. Begründung sind die folgenden known issues:
                        •	Safari iOS: Das ContextMenu funktioniert unter Safari iOS nicht. Wahrscheinliche Ursache: der event contextmenu wird bei long hold nicht ausgelöst. Mögliche Umgehung: https://stackoverflow.com/questions/29228999/jquery-contextmenu-event-not-working-in-ios-8-2/33778163#33778163
                        •	Android Chrome:
                            o	Das ContextMenu wird angezeigt, wenn der Benutzer auf das gewünschte Element einen „long hold“ ausführt.
                            o	Ist das Context Menu zu lange sodass es über den Bildschirmbereich hinausreicht, so gibt es Probleme bei der Bedienung. z.B. beim Aufklappen von Submenus, die erst in den sichtbaren Bereich gewischt werden müssen. Tippt man auf dieses Submenu, schließt sich das gesamte Menu. Teilweise können auch unsichtbare Menupunkte auch nicht in den sichtbaren Bereich gewischt werden. Abhilfe: Keine Submenüs bzw. dafür sorgen, dass die erste Ebene des Menüs nie größer ist als der Bildschirmbereich.
                            o	Zusätzlich zur Anzeige des ContextMenüs, wird die Default-Aktion (=Markierung es aktuellen Wortes) ebenfalls ausgeführt. Das führt zu einer störenden Anzeige des aktuell markierten Wortes.
                     * */
                    let activateContextMenu = Utilities_1.synUtil.Configs.getValue("webtoolkitactivatecontextmenu", "Y");
                    if (activateContextMenu === "Y") {
                        eventObjectContextMenu.preventDefault();
                        let $rows = $elem.find("tbody");
                        let bClickedOnSelectableRows = false;
                        if ($rows.find($(eventObjectContextMenu.target)).length > 0)
                            bClickedOnSelectableRows = true;
                        if (bClickedOnSelectableRows) {
                            // Es wurde mit der rechten Mouse-Taste auf einen Bereich geklickt, der die selektierbaren Rows anzeigt
                            let selectedRows = $elem.data("kendoGrid").select();
                            if (selectedRows.find($(eventObjectContextMenu.target)).length === 0) {
                                // Dafür sorgen, dass die Row, auf die geklickt wurde, auch selektiert wird - außer sie ist bereits selektiert
                                // --> Damit wird verhindert, dass eine Mehrfachselektion verloren geht.
                                $(eventObjectContextMenu.target).trigger("click");
                                // Der Aufruf von click löst an dieser Stelle (derzeit) keinen AJAX-Request oder sonstigen asynchronen Request aus.
                                // Der SelektionContext ist an dieser Stelle synchron unmittelbar nach Aufruf von click() korrekt gesetzt.
                                // --> Direkter Trigger-Aufruf von onObjectContextMenu ist an dieser Stelle möglich.
                                // Sollte sich das einmal ändern, so ist ähnlich vorzugehen wie in Tree.ts
                                $elem.trigger("onObjectContextMenu", [eventObjectContextMenu]);
                            }
                            else
                                $elem.trigger("onObjectContextMenu", [eventObjectContextMenu]);
                        }
                        else {
                            // Es wurde mit der rechten Mouse-Taste auf einen Bereich geklickt, der KEINE selektierbaren Rows anzeigt
                            // --> ev. vorhandene Selektion im Grid löschen, damit nur mehr die Methoden im Contextmenu angezeigt werden, die keine Selektion erfordern.
                            // Das entspricht dem Verhalten des Desktops-Clients
                            $elem.data("kendoGrid").clearSelection();
                            $elem.trigger("onObjectContextMenu", [eventObjectContextMenu]);
                        }
                    }
                }
            });
        }
    }
    static initListControlAsync($elem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const synData = ListImpl.getData($elem);
            const colLayout = yield ListImpl.getColLayoutAsync($elem);
            ListImpl.setPrivateData($elem, ListPrivateDataKeys.Columns, colLayout.columns);
            ListImpl.updateLayoutEtag($elem, colLayout);
            $elem.kendoGrid({
                columns: ListImpl.toKendoGridColumns($elem, colLayout),
                dataSource: new kendo.data.DataSource({
                    transport: {
                        read: (options) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                            try {
                                $elem.trigger("beginDataBinding");
                                const grid = $elem.data("kendoGrid");
                                const gridOptions = grid.getOptions();
                                const ctx = {
                                    columnNames: gridOptions.columns.map(col => FieldNameConverter_1.FieldNameConverter.fromInternalName(col.field))
                                };
                                const dataItems = yield synData.dataItemGenerator(ctx);
                                const fetchedIds = dataItems.map(di => di.id);
                                $elem.trigger("fetchedIds", [fetchedIds]);
                                options.success(dataItems);
                                $elem.trigger("dataBound");
                            }
                            finally {
                                $elem.trigger("endDataBinding");
                            }
                        })
                    },
                    schema: {
                        model: {
                            fields: ListImpl.getColumnSchema(colLayout)
                        }
                    },
                    sort: ListImpl.getInitialSort(colLayout),
                }),
                autoBind: synData.autoBind,
                selectable: "Multiple" === (synData === null || synData === void 0 ? void 0 : synData.selectionMode) ? "multiple, row" : "row",
                pageable: false,
                resizable: synData.resizableCols,
                reorderable: synData.reorderableCols,
                sortable: synData.sortableCols ? { mode: "single", allowUnsort: false } : false,
                filterable: true,
                scrollable: true,
                navigatable: true,
                filterMenuOpen: (e) => {
                    const columns = ListImpl.getColumns($elem);
                    const targetCol = columns.find(col => col.dataField === FieldNameConverter_1.FieldNameConverter.fromInternalName(e.field));
                    ListFilterable_1.ListFilterable.prepareListFilterMenu(e.container, targetCol);
                },
                change(e) {
                    const grid = e.sender;
                    let self = this;
                    if (!ListImpl.getPrivateData($elem, ListPrivateDataKeys.LastSelection))
                        ListImpl.setPrivateData($elem, ListPrivateDataKeys.LastSelection, $elem.find(".k-state-selected"));
                    let continueObject = {
                        continueCallback(cont) {
                            if (cont) {
                                ListImpl.setPrivateData($elem, ListPrivateDataKeys.LastSelection, $elem.find(".k-state-selected"));
                                let selectedIds = ListImpl.getSelectedIds($elem);
                                $elem.trigger("selectionChanged", [selectedIds]);
                            }
                            else {
                                if (ListImpl.getPrivateData($elem, ListPrivateDataKeys.LastSelection).is(self.select()))
                                    $(self.select()).removeClass("k-state-selected");
                                else {
                                    $(self.select()).removeClass("k-state-selected");
                                    ListImpl.getPrivateData($elem, ListPrivateDataKeys.LastSelection).addClass("k-state-selected");
                                }
                            }
                        }
                    };
                    if (synData.raiseBeforeSelectionChanged)
                        $elem.trigger("beforeSelectionChanged", [continueObject]);
                    else
                        continueObject.continueCallback(true);
                },
                dataBound: () => {
                    ListImpl.fixDom($elem);
                    if ($elem.data("kendoGrid"))
                        $elem.trigger("dataBound");
                },
                columnResize: (e) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    if (!ListImpl.isStaticColLayout($elem)) {
                        const columns = e.sender.columns.filter(c => c.field !== "resizeDummy");
                        LayoutStorage_1.LayoutStorage.updateColumnSize(synData.columnOptions, columns);
                        const colLayout = yield ListImpl.getColLayoutAsync($elem);
                        ListImpl.updateLayoutEtag($elem, colLayout);
                    }
                }),
                columnReorder: (e) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    if (!ListImpl.isStaticColLayout($elem)) {
                        LayoutStorage_1.LayoutStorage.updateColumnOrder(synData.columnOptions, e.oldIndex, e.newIndex);
                        const colLayout = yield ListImpl.getColLayoutAsync($elem);
                        ListImpl.updateLayoutEtag($elem, colLayout);
                    }
                }),
                sort: (e) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    if (!ListImpl.isStaticColLayout($elem)) {
                        LayoutStorage_1.LayoutStorage.updateColumnSort(synData.columnOptions, FieldNameConverter_1.FieldNameConverter.fromInternalName(e.sort.field), e.sort.dir);
                        const colLayout = yield ListImpl.getColLayoutAsync($elem);
                        ListImpl.updateLayoutEtag($elem, colLayout);
                    }
                }),
            });
            ListImpl.fixDom($elem);
            ListImpl.registerContextMenu($elem);
            ListImpl.registerDoubleClickHandler($elem);
        });
    }
    static registerDoubleClickHandler($elem) {
        $elem.on("dblclick", "tbody>tr", (e) => {
            const synData = ListImpl.getData($elem);
            const $tr = $(e.target).closest("tr");
            let item = $elem.data("kendoGrid").dataSource.getByUid($tr.attr("data-uid"));
            let itemId = item["id"];
            if (synData.doubleClickAction === true) {
                let action = Utilities_1.synUtil.Configs.getValue("webtoolkitlistdblclickaction", undefined, parseInt(itemId.split("|")[2], 10));
                if (action === "view") {
                    if ((typeof window.synDesktopApp !== "undefined") || (typeof window.synDesktopView !== "undefined"))
                        Utilities_1.synUtil.executeDesktopMethod("cefunc.26", { ids: [itemId] });
                    else
                        synerisMethods_1.synerisMethods.cefunc["26"].impl([itemId], undefined, 0, undefined);
                }
                else if (action === "properties") {
                    if ((typeof window.synDesktopApp !== "undefined") || (typeof window.synDesktopView !== "undefined"))
                        Utilities_1.synUtil.executeDesktopMethod("cefunc.2", { ids: [itemId] });
                    else
                        synerisMethods_1.synerisMethods.cefunc["2"].impl([itemId], undefined, 0);
                }
                else if (action === "url") {
                    if ((typeof window.synDesktopApp !== "undefined") || (typeof window.synDesktopView !== "undefined"))
                        Utilities_1.synUtil.executeDesktopMethod("cefunc.144", { ids: [itemId] });
                    else
                        synerisMethods_1.synerisMethods.cefunc["144"].impl([itemId], undefined, 0);
                }
            }
            $elem.trigger("rowDoubleClicked", [itemId]);
        });
    }
    static getInitialSort(colLayout) {
        let sortColumns = colLayout.columns
            .filter(col => typeof col.sortDirection !== "undefined" && col.sortDirection !== "none");
        const sortItems = sortColumns
            .sort((a, b) => a.sortSeq - b.sortSeq)
            .map(col => { return { field: FieldNameConverter_1.FieldNameConverter.toInternalName(col.dataField), dir: col.sortDirection }; });
        if (!sortItems.length)
            return undefined;
        return sortItems;
    }
    static getColumnSchema(colLayout) {
        let modelFields = {};
        colLayout.columns.forEach((col) => {
            modelFields[FieldNameConverter_1.FieldNameConverter.toInternalName(col.dataField)] = {
                type: col.dbColType === "date" || col.dbColType === "datetime" || col.dbColType === "time" ? "date" : col.dbColType
            };
        });
        return modelFields;
    }
    static getColLayoutAsync($elem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const options = ListImpl.getData($elem);
            if (ListImpl.isStaticColLayout($elem)) {
                const columns = options.columnOptions;
                return { columns };
            }
            return yield LayoutStorage_1.LayoutStorage.getLayoutAsync(options.columnOptions);
        });
    }
    static toKendoGridColumns($elem, colLayout) {
        let gridColumns = colLayout.columns.map((c, idx) => ListImpl.toKendoGridColumnCore($elem, idx, c));
        // Add dummy column to avoid resizing problems
        gridColumns.push({
            field: "resizeDummy",
            title: "",
            template: "",
            filterable: false,
            sortable: false,
            selectable: false,
            headerTemplate: "&nbsp;"
        });
        return gridColumns;
    }
    static toKendoGridColumnCore($elem, columnIndex, col) {
        let gridCol = {
            field: FieldNameConverter_1.FieldNameConverter.toInternalName(col.dataField),
            title: col.title,
            width: col.width,
            template: ListImpl.getGridColumnTemplate($elem, columnIndex, col),
            filterable: ListFilterable_1.ListFilterable.getGridColumnFilterable(ListImpl.getData($elem), col)
        };
        if (col.dbColType === "date" || col.dbColType === "time" || col.dbColType === "datetime")
            gridCol.type = "date";
        return gridCol;
    }
    static getGridColumnTemplate($elem, columnIndex, col) {
        const options = ListImpl.getData($elem);
        const fieldNameConverted = FieldNameConverter_1.FieldNameConverter.toInternalName(col.dataField);
        let hyperlinkFieldName;
        if (!ListImpl.isStaticColLayout($elem))
            hyperlinkFieldName = options.columnOptions.hyperlinkFieldName;
        const iconWsUrl = Utilities_1.synUtil.getWSUrl("Icon");
        const iconSize = ListImpl.getIconSize();
        let dataFormat;
        if (col.dbColType === "date")
            dataFormat = "d";
        else if (col.dbColType === "datetime")
            dataFormat = "G";
        else if (col.dbColType === "time")
            dataFormat = "T";
        let tmpl = "";
        // For boolean columns, center the contained checkbox
        if (col.dbColType === "boolean")
            tmpl += "<div style='text-align: center;'>";
        // Create hyperlink for the first column, if a hyperlink field name has been specified and hyperlink field for the instance contains a hyperlink
        if (hyperlinkFieldName && columnIndex === 0) {
            const hyperlinkFieldNameConverted = FieldNameConverter_1.FieldNameConverter.toInternalName(hyperlinkFieldName);
            tmpl += "# if (typeof data." + hyperlinkFieldNameConverted + " !== 'undefined' && data." + hyperlinkFieldNameConverted + ") {# "
                + "<a href='#= data." + hyperlinkFieldNameConverted + "#' title='#: data." + hyperlinkFieldNameConverted + "#' target='_blank' rel='noopener noreferrer'><span><i class='fa fa-external-link listHyperlink'></i></span></a> #} #";
        }
        // Show icon for columns where the underlying fields have STYLE_SHOWICON set
        if (col.showIcon)
            tmpl += "# if (typeof data." + fieldNameConverted + "_icon" + " !== 'undefined') {# <img class='listElemIcon' src='" + iconWsUrl + "#=data." + fieldNameConverted + "_icon" + "#/" + iconSize.toString() + "'> #} else {# <img class='listElemIcon' src='" + iconWsUrl + "transparent/" + iconSize.toString() + "'> #} #";
        // Otherwise, if the column is the first column and the list control has been initialized with showIcons, show the instance icon
        else if (options.showIcons && columnIndex === 0)
            tmpl += "<img class='listElemIcon' src='" + iconWsUrl + "#= data.icon || \"transparent\"" + "#/" + iconSize.toString() + "'> ";
        // Colorize the column contents based on cgdocument.listtextrgb (fallback: black)
        tmpl += "<span style='color: \\##:data.cgdocument_listtextrgb || '000000'#;'>";
        // Formats time, date and dateTime columns
        if (dataFormat)
            tmpl += "#= data." + fieldNameConverted + "? kendo.toString(data." + fieldNameConverted + ", '" + dataFormat + "') : ''#";
        // Formats number columns
        else if (col.dbColType === "number") {
            // Defined decimal digits
            if (col.decimalPlaces > 0)
                tmpl += "#= data" + fieldNameConverted + "? kendo.toString(data." + fieldNameConverted + ", 'n" + col.decimalPlaces + "') : '' #";
            // Default numeric format
            else
                tmpl += "#= data." + fieldNameConverted + "? data." + fieldNameConverted + " : '' #";
        }
        // For boolean fields, display a checkbox instead. If the field value is true, check the checkbox
        else if (col.dbColType === "boolean")
            tmpl += "<input type='checkbox' disabled='disabled' #= data." + fieldNameConverted + "? 'checked=\"checked\"' : '' # />";
        // Some field types cannot be displayed, they should not appear in a column layout anyway, 
        // but it needs to be handled gracefully anyway
        else if (col.dbColType !== "hide")
            tmpl += "#: data." + fieldNameConverted + " || '' #";
        tmpl += "</span>";
        // For boolean columns, close the centering <div> we opened at the start
        if (col.dbColType === "boolean")
            tmpl += "</div>";
        return tmpl;
    }
    static setData($elem, data) {
        $elem.data("synList", data);
    }
    static getData($elem) {
        return $elem.data("synList");
    }
    static setPrivateData($elem, key, data) {
        $elem.data(ListPrivateDataKeys[key], data);
    }
    static getPrivateData($elem, key) {
        return $elem.data(ListPrivateDataKeys[key]);
    }
    static deletePrivateData($elem, key) {
        $elem.removeData(ListPrivateDataKeys[key]);
    }
    static getIconSize() {
        if (Utilities_1.synUtil.isHDScreen)
            return 32;
        return 16;
    }
    static fixDom($elem) {
        const grid = $elem.data("kendoGrid");
        if (grid) {
            const synData = ListImpl.getData($elem);
            grid.tbody.find("tr").click((evt) => {
                if (!ListImpl.isFocused($elem) && evt.which === 1 /* Left mouse button */) {
                    const $tr = $(evt.target).closest("tr");
                    const elem = $elem.data("kendoGrid").dataItem($tr);
                    if (elem.get("selected")) {
                        $elem.trigger("itemsRefocusRequested");
                    }
                }
            });
            if (!synData.useAlternateRowStyle)
                grid.tbody.find("tr.k-alt").removeClass("k-alt");
        }
        // Set flexbox layout for grid control
        $elem.css({
            "display": "flex",
            "flex-direction": "column"
        });
        $elem.children(".k-grid-header").css("flex-grow", "0");
        // Remove animation when opening filter menu for list column
        $elem.children(".k-grid-header").find("th").each((_idx, elem) => {
            let initable = $(elem).data("kendoFilterMenu");
            if (!initable)
                initable = $(elem).data("kendoFilterMultiCheck");
            if (initable) {
                const initOrig = initable._init;
                initable._init = function () {
                    initOrig.apply(this, arguments);
                    this.popup.options.animation.open.duration = 0;
                    this.popup.options.animation.close.duration = 0;
                };
            }
        });
        $elem.children(".k-grid-content")
            .on("click", (evt) => {
            if ($(evt.target).is($elem.children(".k-grid-content"))) {
                $elem.data("kendoGrid").clearSelection();
                $elem.trigger("selectionChanged", [ListImpl.getSelectedIds($elem)]);
            }
        })
            .css({
            "height": "",
            "flex-grow": "1"
        });
        // ResizeDummy column should not be draggable or highlightable
        $elem.find("th[data-field='resizeDummy']")
            .css({
            "pointer-events": "none",
            "box-shadow": "none !important"
        });
        // Add special class to resizeDummy column
        $elem.find("td[data-field='resizeDummy']").addClass("resizeDummy");
        // Remove tooltips on filter popup
        $elem.find(".k-grid-filter").attr("title", "");
        $elem.find(".k-input").attr("title", "");
    }
    static isStaticColLayout($elem) {
        const options = ListImpl.getData($elem);
        return Array.isArray(options.columnOptions);
    }
}
/**
 * Contains all default values for option parameters not passed by the caller
 */
ListImpl.DefaultOptions = {
    columnOptions: undefined,
    dataItemGenerator: undefined,
    autoBind: true,
    resizableCols: true,
    reorderableCols: true,
    sortableCols: true,
    filterableCols: true,
    raiseBeforeSelectionChanged: false,
    showIcons: true,
    lockable: false,
    doubleClickAction: true,
    useAlternateRowStyle: true
};
(($) => {
    $.fn.synList = function () {
        if (!arguments.length || typeof arguments[0] === "object")
            // eslint-disable-next-line no-null/no-null
            return ListImpl.initAsync.apply(null, [this].concat(Array.prototype.slice.call(arguments)));
        else if (typeof arguments[0] === "string" && ListImpl[arguments[0]])
            // eslint-disable-next-line no-null/no-null
            return ListImpl[arguments[0]].apply(null, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else
            $.error("Method " + arguments[0] + " does not exist on jQuery.synList");
    };
})(jQuery);
